import { construirSombra } from '@/styles/theme';
import styled, { css } from 'styled-components';

export type CardVariant = 'surface' | 'classic' | 'ghost';

export type CardProps = {
  $size: number;
  $insetContent: boolean;
  $variant: CardVariant;
  $interactive: boolean;
  $removeFlex?: boolean;
};

export const Card = styled.div<CardProps>`
  display: flex;
  ${({ $removeFlex }) => {
    if ($removeFlex) return '';
    return css`
      flex: 1;
    `;
  }}

  background-color: ${({ $variant, theme }) =>
    $variant !== 'ghost' ? theme.panel.translucent : 'none'};

  ${({ $variant }) => {
    if ($variant === 'classic') {
      return css`
        box-shadow: ${construirSombra('shadow_2')};
      `;
    }
  }}

  ${({ theme, $insetContent, $size }) => {
    if ($insetContent) return null;
    return css`
      padding: ${theme.spacing[$size + 2]}px;
    `;
  }};

  ${({ theme, $variant, $size }) => {
    if ($variant === 'ghost') return '';
    return css`
      border: 1px solid ${theme.colors.neutral.neutral_alpha[6]};
      border-radius: ${theme.radius[$size + 1]}px;
    `;
  }}

  ${({ $interactive, theme, $variant, $size }) => {
    if (!$interactive) return '';
    const sombra = css`
      box-shadow: ${construirSombra('shadow_3')};
    `;

    return css`
      cursor: pointer;

      @media (min-width: 769px) {
        &:hover {
          background-color: ${theme.colors.neutral.neutral_alpha[3]};
          border: 1px solid ${theme.colors.neutral.neutral_alpha[6]};
          border-radius: ${theme.radius[$size + 2]}px;
          ${$variant === 'classic' ? sombra : ''}
        }
      }

      &:active {
        background-color: ${theme.colors.neutral.neutral_alpha[4]};
        border-radius: ${theme.radius[$size + 2]}px;
      }
    `;
  }}
`;
